import React from 'react'
import {
    BackButton,
    BlocLocationField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue4() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Où se situe votre bien ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={15} time={3} />
            </div>

            {/* 
						SI Recherche : on demande la localisation departement
						Si trouver : on demande la localisation ville (cp)
					*/}
            <Conditionnal
                linked_data_id="prj_maturite"
                isEqualTo
                targetDataValueCompare="RECHERCHE"
            >
                <div className="Container">
                    <BlocLocationField
                        key="key14"
                        nbcolumn={1}
                        linked_data_id="prj_localisation_dep"
                        Departement
                        label="Département du projet (obligatoire)"
                        placeholder="Ex : Finistère ou 29"
                    />
                </div>

                <div className="Container">
                    <Title
                        maintitle="Si vous avez une idée précise de la ville de recherche : "
                        secondarytitlebold="Cela permettra d'améliorer l'estimation fournie"
                    />
                    <BlocLocationField
                        key="key15"
                        nbcolumn={1}
                        linked_data_id="prj_localisation_ville"
                        Ville
                        label="Ville ou code postal (optionnel)"
                        placeholder="Ex : Finistère ou 29120"
                    />
                </div>
            </Conditionnal>
            <Conditionnal
                linked_data_id="prj_maturite"
                isNotEqualTo
                targetDataValueCompare="RECHERCHE"
            >
                <div className="Container">
                    <BlocLocationField
                        key="key15"
                        nbcolumn={1}
                        linked_data_id="prj_localisation_ville"
                        Ville
                        label="Ville ou code postal"
                        placeholder="Ex : Finistère ou 29120"
                    />
                </div>
            </Conditionnal>

            {/* 
						Si Trouver renego: on continu sur la vue 25 "crédit a renégo"
						Si Trouver non renégo : on continu sur la vue 5 "montant projet"
						Si recherche : on continu sur la vue 6 "info emprunteur" en esquivant la 5 
					*/}
            <Conditionnal
                linked_data_id="prj_maturite"
                isEqualTo
                targetDataValueCompare="TROUVE"
            >
                <Conditionnal
                    linked_data_id="prj_localisation_ville"
                    isNotEmpty
                    isNotNull
                >
                    <Conditionnal
                        linked_data_id="prj_type"
                        isNotEqualTo
                        targetDataValueCompare="RENEGOCIATION"
                    >
                        <div className="SubmitButtonContainer">
                            <Button text="Suivant" targetView={5} />
                        </div>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="prj_type"
                        isEqualTo
                        targetDataValueCompare="RENEGOCIATION"
                    >
                        <div className="SubmitButtonContainer">
                            <Button text="Suivant" targetView={25} />
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
            <Conditionnal
                linked_data_id="prj_maturite"
                isEqualTo
                targetDataValueCompare="RECHERCHE"
            >
                <Conditionnal
                    linked_data_id="prj_localisation_dep"
                    isNotEmpty
                    isNotNull
                >
                    <div className="SubmitButtonContainer">
                        <Button text="Suivant" targetView={6} />
                    </div>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
